export default "__VITE_ASSET__Xdf53ClK__"